import { render } from "./licensee.vue?vue&type=template&id=10873177&scoped=true"
import script from "./licensee.vue?vue&type=script&lang=js"
export * from "./licensee.vue?vue&type=script&lang=js"

import "./licensee.vue?vue&type=style&index=0&id=10873177&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10873177"]])

export default __exports__